import React from 'react';

function HotspotList({ infoSpots, links, scenes, onEditInfoSpot, onDeleteInfoSpot, onEditLink, onDeleteLink }) {
    const hasItems = (infoSpots && infoSpots.length > 0) || (links && links.length > 0);

    return (
        <div className="admin-hotspot-list">
            <h4>Hotspots in Scene</h4>

            {!hasItems && (
                <p className="admin-empty-list">No hotspots yet. Click on the panorama to place one.</p>
            )}

            {infoSpots && infoSpots.length > 0 && (
                <div className="admin-list-section">
                    <h5>📌 Info Hotspots ({infoSpots.length})</h5>
                    {infoSpots.map((spot, idx) => (
                        <div key={spot.id || idx} className="admin-list-item">
                            <div className="admin-list-item-info">
                                <span className="admin-list-item-badge admin-badge-info">Info</span>
                                <span className="admin-list-item-name">
                                    {spot.solutionModelData?.infoSpot || 'Untitled'}
                                </span>
                                <span className="admin-list-item-pos">
                                    ({spot.position?.x?.toFixed(0)}, {spot.position?.y?.toFixed(0)}, {spot.position?.z?.toFixed(0)})
                                </span>
                            </div>
                            <div className="admin-list-item-actions">
                                <button
                                    className="admin-list-btn admin-list-btn-edit"
                                    onClick={() => onEditInfoSpot(spot, idx)}
                                    title="Edit"
                                >
                                    ✏️
                                </button>
                                <button
                                    className="admin-list-btn admin-list-btn-delete"
                                    onClick={() => onDeleteInfoSpot(spot.id, idx)}
                                    title="Delete"
                                >
                                    ❌
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {links && links.length > 0 && (
                <div className="admin-list-section">
                    <h5>🔗 Transition Nodes ({links.length})</h5>
                    {links.map((link, idx) => (
                        <div key={link.id || idx} className="admin-list-item">
                            <div className="admin-list-item-info">
                                <span className="admin-list-item-badge admin-badge-link">Link</span>
                                <span className="admin-list-item-name">{link.name || 'Untitled'}</span>
                                <span className="admin-list-item-dest">
                                    → {scenes?.find(s => s.sceneIndex === link.linkTo)?.name || `Scene ${link.linkTo}`}
                                </span>
                            </div>
                            <div className="admin-list-item-actions">
                                <button
                                    className="admin-list-btn admin-list-btn-edit"
                                    onClick={() => onEditLink(link, idx)}
                                    title="Edit"
                                >
                                    ✏️
                                </button>
                                <button
                                    className="admin-list-btn admin-list-btn-delete"
                                    onClick={() => onDeleteLink(link.id, idx)}
                                    title="Delete"
                                >
                                    ❌
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default HotspotList;
